import Button from "@material-ui/core/Button";
import { TextField } from "@material-ui/core";
import FirebaseService from "../../../../services/firebase/FirebaseService";
import googleIcon from "../../../../assets/icons/google-icon.jpeg";
import "./NewClassView.css";
import { GENERAL_MAX_LENGTH } from "../../../../utils/stringFormatting";
import WordDivider from "../../../WordDivider";
import { ReadleeGoogleCourse } from "../../../../interfaces/Google";

// Modal for creating new class via Google Classroom or title input

interface NewClassViewProps {
  className: string;
  googleClasses: Array<ReadleeGoogleCourse>;
  classesToBeMade: Array<ReadleeGoogleCourse>;
  setClassName: (arg: string) => void;
  setGoogleClasses: (arg: Array<ReadleeGoogleCourse>) => void;
  setClassesToBeMade: (arg: Array<ReadleeGoogleCourse>) => void;
}

function NewClassView(props: NewClassViewProps) {
  // manage which google classes are selected
  const manageCustomClass = (shouldAdd: boolean, target: ReadleeGoogleCourse) => {
    const classesToBeMadeCopy = props.classesToBeMade;
    if (shouldAdd) {
      classesToBeMadeCopy.push(target);
    } else {
      classesToBeMadeCopy.splice(classesToBeMadeCopy.indexOf(target), 1);
    }
    props.setClassesToBeMade(classesToBeMadeCopy);
  };

  return props.googleClasses.length > 0 ? (
    <div className="newClassView">
      <div className="title">Google Classroom</div>
      <div className="subtext">Select all the classes you want to import.</div>
      <div className="google-content">
        {props.googleClasses.map(googleClass => (
          <div>
            <div className="google-class">
              <input
                onChange={v => manageCustomClass(v.target.checked, googleClass)}
                style={{ marginTop: "10px", marginRight: "5px" }}
                type="checkbox"
              />
              <div
                style={{
                  fontSize: "14px",
                  marginTop: "7px",
                }}
              >
                {googleClass.name}
              </div>
            </div>
            <hr />
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="newClassView">
      <div className="title">Google Classroom</div>
      <div className="subtext">We recommend importing your classes for easy student sign in.</div>
      <div className="center-contents">
        <Button
          className="google-button"
          onClick={() => {
            FirebaseService.getGoogleClassrooms().then(classes => {
              props.setGoogleClasses(classes);
            });
          }}
        >
          <img height={15} style={{ marginRight: "15px" }} src={googleIcon} alt="google" />
          Import from Google
        </Button>
      </div>
      <WordDivider>OR</WordDivider>
      <div style={{ marginTop: "10px" }} className="title">
        Manually Create Class
      </div>
      <div className="center-contents">
        <TextField
          className="class-name-input"
          InputProps={{ disableUnderline: true }}
          inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
          value={props.className}
          onChange={e => props.setClassName(e.target.value)}
          placeholder="Name of Class"
        />
      </div>
    </div>
  );
}

export default NewClassView;
